var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Appsignal from "@appsignal/javascript";
import { ErrorBoundary } from "@appsignal/react";
import { v1 } from "@variable/ui-icons";
var FallbackErrorBoundary = function (props) {
    var _a;
    var FallbackComponent = function (props) { return (_jsx("div", __assign({ style: { margin: "auto", width: "50%", marginTop: "200px" } }, { children: _jsx(v1.InternalServerError, {}) }))); };
    var appSignal = new Appsignal({
        key: props.APPSIGNAL_KEY || "",
        //@ts-ignore
        active: props.APPSIGNAL_ENABLE || true,
        revision: ((_a = document.querySelector('meta[NAME="APP_VERSION"]')) === null || _a === void 0 ? void 0 : _a.textContent) || ""
    });
    return (_jsx(ErrorBoundary, __assign({ instance: appSignal, tags: props.tags || [], fallback: function (error) {
            if (props.component) {
                return _jsx(props.component, __assign({}, props));
            }
            return _jsx(FallbackComponent, {});
        } }, { children: props.children })));
};
export { FallbackErrorBoundary };
